<template>

    <div class="lamp__screen noselect">

        <markdown class="lamp__title" :text="$t('stories_screen_4_text')" :color="'#3a4f41'"></markdown>

    </div>

</template>

<script>

import Markdown from '@/components/Markdown'

export default {

    name: 'lamp',

    components: { Markdown },

    props: {},

    methods: {}

}

</script>

<style scoped lang="scss">

    .lamp {
        &__screen {
            display: flex;
            align-items: flex-end;
            width: 100%;
            height: 100%;
            background-color: $forest;
            padding: 68px 24px;
            background-image: url("/img/stories/illustrationStoriesLight@3x.png");
            background-repeat: no-repeat;
            background-position-x: center;
            background-position-y: top;
            background-size: contain;
        }

        &__title {
            color: $sand;
            font-size: 22px;
            font-weight: bold;
            text-align: center;
        }
    }

</style>

